<template>
  <div id="app">
    <router-view/>
    <!-- <div v-show="$route.path == '/'">
      <div>
        <div class="logintitle">
          <img class="logoimg" src="/static/img/logo.png">
        </div>
        <div class="inputcont">
          <img class="fl headtext" src="/static/img/mobile.png">
          <input placeholder="请输入手机号/邮箱" class="text" type="text"
          v-model="loginCode">
        </div>
        <div class="inputcont">
          <img class="fl headtext" src="/static/img/pwd.png">
          <input placeholder="请输入密码" id="pwd" class="text" :type="inputType" v-model="password">
          <img class="fr spwd" v-show="isPass" src="/static/img/hidepwd.png" @click="showPass()">
          <img class="fr spwd" v-show="!isPass" src="/static/img/showpwd.png" @click="hidePass()">
        </div>
        <div class="loginbtdiv"><mt-button class="login-btn" size="large" type="primary" @click="sure()">登录</mt-button>
        </div>
        <div class="bottomlogin">
          <router-link to="/findpass" class="fl">忘记密码</router-link>
          <router-link to="/reg" class="fr">立即注册</router-link>
        </div>
        <div class="ts">
          <h5>温馨提示：</h5>
          由于各手机浏览器支持功能不同，若您是安卓手机建议用
          <b>QQ浏览器</b>进行签署，若是苹果手机建议您使用苹果自带浏览器<b>Safari浏览器</b>进行签署！
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
  import { Toast } from 'mint-ui';
  import cheader from '@/components/header';
  import clogo from '@/components/logo';
  import NoTrace from '@/js/noTrace'
  export default {
    name: 'login',
    data () {
      return {
        isPass: 'true',
        inputType: 'password',
        loginCode:'',
        password:''
      }
    },
    methods: {
      sure: function(){
        if (this.loginCode == null || this.loginCode == '') {
          this.$toast("请输入手机号");
          return;
        }
        if (this.password == null || this.password == '') {
          this.$toast("请输入密码");
          return;
        }
        this.$http.post(
            domain("_loginUrl"),
            {
              'loginCode':this.loginCode,
              'password':$.md5(this.password)
            },
            {emulateJSON: true}
        )
        .then(function(response){  //接口返回数据
            if(response.body.result == 0){
              this.$toast('帐号未注册');
            }else if(response.body.result == 2){
              this.$toast('密码错误');
            }else if(response.body.result == 3){
              this.$toast('帐号冻结');
            }else if(response.body.result == 4){
              this.loginCode='';
              this.password='';
              localStorage.setItem("ticketId", response.body.ticketId);
              localStorage.setItem("cusType", response.body.cusType);
              localStorage.setItem("personId", response.body.personId);
              localStorage.removeItem("tab-selected");
              localStorage.setItem("tab-selected", 'tab-container1');
              this.$router.push('/bindMobile');
            }else{
              this.loginCode='';
              this.password='';
              localStorage.setItem("ticketId", response.body.ticketId);
              localStorage.setItem("cusType", response.body.cusType);
              localStorage.removeItem("tab-selected");
              localStorage.setItem("tab-selected", 'tab-container1');
              this.$router.push('/main');
            }
            },function(error){
        })
      },
      showPass: function(){
        this.isPass = false;
        this.inputType = 'text';
      },
      hidePass: function(){
        this.isPass = true;
        this.inputType = 'password';
      }
    },
    components:{
      cheader,
      clogo
    },
    mounted () {
      NoTrace.init()
    }
  }
</script>
<style>
  .toastcustom {
    width: 90%;
  }
  .logoimg{
    width:120px;
  }
  #app{
    height: 100%;
  }
  .logintitle{
    text-align: center;
    padding: 40px 0;
    font-size: 32px;
    color: #7d7d7d;
  }
  .headtext{
    position: absolute;
    top: 15px;
    left:30px;
  }
  .inputcont input[type="text"],
  .inputcont input[type="password"]{
    padding-left:50px;
  }
  .inputcont{
    position: relative;
    padding: 0 10px;
    margin-bottom:25px;
  }
  .spwd{
    position: absolute;
    left: 100%;
    margin-left: -40px;
    top: 20px;
  }
  .inputcont img{
    width: 15px;
  }
  .loginbtdiv{
    padding: 0 10px;
  }
  .bottomlogin{
    overflow:hidden;
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 0 12px;
  }
  .ts{
    padding: 0 12px;
    font-size: 12px;
    color:#999;
    margin-top: 30px;
  }
  .ts h5{
    font-size: 12px;
    color:#26a2ff;
    margin-bottom: 5px;
  }
  .ts b{
    font-weight: 500;
    color:red;
  }
  .bottomlogin a{
    color: #7d7d7d;
  }
  .mint-indicator {
    position: relative;
    z-index: 9;
  }
  .nomalClass {
    font-size: 14px;
    line-height: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/module/index/App.vue